import React, { PureComponent, ReactNode } from 'react';
import Experiment from './Experiment';
import ExperimentProviderContext from '../ExperimentProviderContext';
import { ProviderDefaults } from '../SharedTypes';

const assignFalsy = values => {
  const n = values.shift();
  return (n || n === 0 || n === false) ? n : assignFalsy(values);
};

type ownProps = ProviderDefaults & {
  name: string;
  killSwitch?: string;
  loading?: ReactNode | string;
  loadingDelay?: number;
};

class ExperimentContainer extends PureComponent<ownProps> {
  render() {
    return (
      <ExperimentProviderContext.Consumer>
        {providerState => {
          const { defaults = {}, ...restOfState } = providerState as any || {};
          const {
            identifier,
            environment,
            cacheMinutes,
            ...restOfProps
          } = this.props;

          const expState = {
            ...restOfState,
            ...restOfProps,
            identifier: identifier || defaults.identifier || '',
            environment: environment || defaults.environment || process.env.NODE_ENV,
            cacheMinutes: assignFalsy([cacheMinutes, defaults.cacheMinutes, 15]),
            killSwitch: defaults.killSwitch || 'off'
          };
          return <Experiment {...expState} />;
        }}
      </ExperimentProviderContext.Consumer>
    );
  }
}

ExperimentContainer.contextType = ExperimentProviderContext;

export default ExperimentContainer;
